var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideo56 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 56,
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.2576 28.0627C24.4166 27.9746 24.6109 27.9797 24.765 28.076L32.765 33.076C32.9112 33.1674 33 33.3276 33 33.5C33 33.6724 32.9112 33.8326 32.765 33.924L24.765 38.924C24.6109 39.0203 24.4166 39.0254 24.2576 38.9373C24.0986 38.8492 24 38.6818 24 38.5V28.5C24 28.3182 24.0986 28.1508 24.2576 28.0627ZM25 29.4021V37.5979L31.5566 33.5L25 29.4021Z",
  fill: "var(--icon-decorative-coral)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.5 6C16.2239 6 16 6.22386 16 6.5C16 6.77614 16.2239 7 16.5 7H38.5C38.7761 7 39 6.77614 39 6.5C39 6.22386 38.7761 6 38.5 6H16.5ZM12 12.5C12 12.2239 12.2239 12 12.5 12H42.5C42.7761 12 43 12.2239 43 12.5C43 12.7761 42.7761 13 42.5 13H12.5C12.2239 13 12 12.7761 12 12.5ZM10.5 19C9.57174 19 8.6815 19.3687 8.02513 20.0251C7.36875 20.6815 7 21.5717 7 22.5V44.5C7 45.4283 7.36875 46.3185 8.02513 46.9749C8.6815 47.6312 9.57174 48 10.5 48H44.5C45.4283 48 46.3185 47.6312 46.9749 46.9749C47.6313 46.3185 48 45.4283 48 44.5V22.5C48 21.5717 47.6313 20.6815 46.9749 20.0251C46.3185 19.3687 45.4283 19 44.5 19H10.5ZM10.5 18C9.30653 18 8.16193 18.4741 7.31802 19.318C6.47411 20.1619 6 21.3065 6 22.5V44.5C6 45.6935 6.47411 46.8381 7.31802 47.682C8.16193 48.5259 9.30653 49 10.5 49H44.5C45.6935 49 46.8381 48.5259 47.682 47.682C48.5259 46.8381 49 45.6935 49 44.5V22.5C49 21.3065 48.5259 20.1619 47.682 19.318C46.8381 18.4741 45.6935 18 44.5 18H10.5Z",
  fill: "currentColor"
})));
export default SvgVideo56;